module.exports = __webpack_public_path__ + "static/media/404.864ccb8a.png";